import { render, staticRenderFns } from "./ArrowBoxSvg.vue?vue&type=template&id=08bb6113"
import script from "./ArrowBoxSvg.vue?vue&type=script&lang=js"
export * from "./ArrowBoxSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports